'use client'
import { getEntryPoint, KERNEL_V3_1, KERNEL_V3_0, KERNEL_V2_4 } from '@zerodev/sdk/constants';
import { ProviderKernelVersionEnum } from '@dynamic-labs/sdk-api-core';
import { logger } from './logger.js';

const getKernelVersion = (kernelVersion, entryPointAddress) => {
    if (kernelVersion === ProviderKernelVersionEnum.V31 ||
        (kernelVersion === undefined &&
            entryPointAddress.address === getEntryPoint('0.7').address)) {
        return KERNEL_V3_1;
    }
    else if (kernelVersion === ProviderKernelVersionEnum.V30) {
        return KERNEL_V3_0;
    }
    else if (kernelVersion === ProviderKernelVersionEnum.V24 ||
        entryPointAddress.address === getEntryPoint('0.6').address // v0.6 only supports v2.4
    ) {
        return KERNEL_V2_4;
    }
    else {
        logger.error('Invalid kernel version', kernelVersion);
        return KERNEL_V3_1;
    }
};

export { getKernelVersion };
